import GridStitcher from '../core/GridStitcher';

export default function useGridStitcher() {
  const stitcher = new GridStitcher();
  const stitch = (options) => stitcher.stitchImages(options);
  return { stitch };
}